import { Routes } from '@angular/router';
import { AccountsComponent } from './accounts.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { ReceiptComponent } from './receipt/receipt.component';
import { ReceivablesComponent } from "./receivables/receivables.component";
import { PayablesComponent } from "./payables/payables.component";
import { AccountsGuard } from "./accounts.guard";
import { GeneratedInvoicesComponent } from "./receivables/generated-invoices/generated-invoices.component";
import { InvoiceDispatchComponent } from './receivables/invoice-dispatch/invoice-dispatch.component';
import { InvoiceDetailComponent } from "./receivables/generated-invoices/invoice-detail/invoice-detail.component";
import { GeneratedReceiptsComponent } from "./receivables/generated-receipts/generated-receipts.component";
import { ReceiptDetailComponent } from "./receivables/generated-receipts/receipt-detail/receipt-detail.component";
import { AddEditJournalEntryComponent } from "./journal-entries/add-edit-journal-entry/add-edit-journal-entry.component";
import { JournalEntriesComponent } from "./journal-entries/journal-entries.component";
import { JournalEntryDetailComponent } from "./journal-entries/journal-entry-detail/journal-entry-detail.component";
import { ImportJournalEntriesComponent } from "./journal-entries/import-journal-entries/import-journal-entries.component";
import { GeneralLedgerComponent } from "./ledgers/general-ledger/general-ledger.component";
import { PartnerLedgerComponent } from "./ledgers/partner-ledger/partner-ledger.component";
import { PaymentTransactionsComponent } from "./payment-transactions/payment-transactions.component";
import { GeneratedBillsComponent } from "./payables/generated-bills/generated-bills.component";
import { BillDetailComponent } from "./payables/generated-bills/bill-detail/bill-detail.component";
import { GeneratedVouchersComponent } from "./payables/generated-vouchers/generated-vouchers.component";
import { VoucherDetailComponent } from "./payables/generated-vouchers/voucher-detail/voucher-detail.component";
import { DebitNoteComponent } from "./debit-note/debit-note.component";
import { AddEditDebitNoteComponent } from "./debit-note/add-edit-debit-note/add-edit-debit-note.component";
import { DebitNoteDetailComponent } from "./debit-note/debit-note-detail/debit-note-detail.component";
import { CreditNoteComponent } from "./credit-note/credit-note.component";
import { AddEditCreditNoteComponent } from "./credit-note/add-edit-credit-note/add-edit-credit-note.component";
import { CreditNoteDetailComponent } from "./credit-note/credit-note-detail/credit-note-detail.component";
import { NewFinanceNotesComponent } from './notes/new-finance-notes.component';
import { ApplyReceiptInvoiceComponent } from "./receivables/apply-receipt-invoice/apply-receipt-invoice.component";
import { ApplyVoucherBillComponent } from "./payables/apply-voucher-bill/apply-voucher-bill.component";
import { ProfitAndLossComponent } from "./reports/profit-and-loss/profit-and-loss.component";
import { BalanceSheetComponent } from "./reports/balance-sheet/balance-sheet.component";
import { TrialBalanceComponent } from "./reports/trial-balance/trial-balance.component";
import { TaxReportComponent } from "./reports/tax-report/tax-report.component";
import { AgedReceivableComponent } from "./reports/aged-receivable/aged-receivable.component";
import { AgedPayableComponent } from "./reports/aged-payable/aged-payable.component";
import { AgingReportComponent } from './reports/aging/aging-report.component';
import { StandardReportComponent } from './reports/standard/standard-report.component';
import { SalesRegisterComponent } from './reports/sales-register/sales-register.component';
import { ReceiptEntryComponent } from "./receivables/generated-receipts/receipt-entry/receipt-entry.component";
import { BankAccountEntryComponent } from "./bank-account/bank-account-entry/bank-account-entry.component";
import { VoucherEntryComponent } from './payables/generated-vouchers/voucher-entry/voucher-entry.component';
import { CostCenterComponent } from './cost-center/cost-center.component';
import { app_permissions } from '../security/app-permissions';
import { PermissionGuard } from '../security/permission.guard';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { BankReconciliationShellComponent } from './bank-reconciliation/shell/bank-reconciliation-shell.component';
import { BankStatementsComponent } from './bank-reconciliation/statements/bank-statements.component';
import { BankStatementImportComponent } from './bank-reconciliation/import/bank-statement-import.component';
import { BankStatementDetailComponent } from './bank-reconciliation/detail/bank-statement-detail.component';
import { BankReconciliationWorkspaceComponent } from './bank-reconciliation/workspace/bank-reconciliation-workspace.component';
import { BankReconciliationRulesComponent } from './bank-reconciliation/rules/bank-reconciliation-rules.component';
import { BankReconciliationRuleFormComponent } from './bank-reconciliation/rules/bank-reconciliation-rule-form.component';
import { BankReconciliationExceptionsComponent } from './bank-reconciliation/exceptions/bank-reconciliation-exceptions.component';
import { BankReconciliationDashboardComponent } from './bank-reconciliation/dashboard/bank-reconciliation-dashboard.component';
import { BankReconciliationReportsComponent } from './bank-reconciliation/reports/bank-reconciliation-reports.component';
import { BankReconciliationStatementReportComponent } from './bank-reconciliation/reports/bank-reconciliation-statement-report.component';
import { AccountingPeriodLocksComponent } from './admin/accounting-period-locks/accounting-period-locks.component';
import { ManualEntryControlsComponent } from './admin/manual-entry-controls/manual-entry-controls.component';
import { ManualReceivableEntryComponent } from './receivables/manual-receivable-entry/manual-receivable-entry.component';
import { ManualPayableEntryComponent } from './payables/manual-payable-entry/manual-payable-entry.component';
import { ReceivableDetailComponent } from './receivables/receivable-detail/receivable-detail.component';
import { PayableDetailComponent } from './payables/payable-detail/payable-detail.component';
import { ManualInvoiceDraftComponent } from './receivables/generated-invoices/manual-invoice-draft/manual-invoice-draft.component';
import { NonPoBillDraftComponent } from './payables/generated-bills/non-po-bill-draft/non-po-bill-draft.component';
import { BankAccountsComponent } from './banking/bank-accounts/bank-accounts.component';
import { BankAccountFormComponent } from './banking/bank-accounts/bank-account-form.component';
import { BankAccountViewComponent } from './banking/bank-accounts/bank-account-view.component';
import { BanksComponent } from './banking/banks/banks.component';
import { MatchingDashboardComponent } from './payables/ap-matching/matching-dashboard.component';
import { MatchingPoliciesComponent } from './payables/ap-matching/matching-policies.component';
import { PaymentProposalsComponent } from './payables/payment-proposals/payment-proposals.component';
import { PaymentProposalDetailComponent } from './payables/payment-proposals/payment-proposal-detail.component';
import { VendorStatementReconciliationComponent } from './payables/vendor-statements/vendor-statement-reconciliation.component';
import { BulkCostsComponent } from './payables/bulk-costs/bulk-costs.component';
import { BulkCostFormComponent } from './payables/bulk-costs/bulk-cost-form.component';
import { BulkCostDetailComponent } from './payables/bulk-costs/bulk-cost-detail.component';
import { BulkCostAccountDefaultsComponent } from './payables/bulk-costs/bulk-cost-account-defaults.component';
import { EInvoiceComplianceWorkbenchComponent } from './compliance/e-invoice-compliance-workbench.component';
import { WorkforceCashWorkbenchComponent } from './workforce-cash/workforce-cash-workbench.component';
import { WorkforceCashFormComponent } from './workforce-cash/workforce-cash-form.component';
import { WorkforceCashDetailComponent } from './workforce-cash/workforce-cash-detail.component';
import { WorkforceEarningFormComponent } from './workforce-cash/workforce-earning-form.component';
import { WorkforceRateCardFormComponent } from './workforce-cash/workforce-rate-card-form.component';
import { WorkforcePayoutFormComponent } from './workforce-cash/workforce-payout-form.component';
import { ZatcaOnboardingComponent } from './compliance/zatca-onboarding.component';
import { GovernmentOnboardingComponent } from './compliance/government-onboarding.component';

export const accountsRoutes: Routes = [
    {
        path: 'accounts',
        children: [
            {
                path: '',
                component: AccountsComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.accounts.reports.view, scope: 'ANY' }
            },
            {
                path: 'invoice',
                component: InvoiceComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.accounts.invoice.view }
            },
            {
                path: 'receipt',
                component: ReceiptComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.accounts.receipt.view }
            },
            {
                path: 'bank-account-entry/:id',
                children: [
                    {
                        path: 'add',
                        component: BankAccountEntryComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.accounts.bank_account_entry.create }
                    },
                    {
                        path: 'edit/:id',
                        component: BankAccountEntryComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.accounts.bank_account_entry.edit }
                    },
                ]
            },
            {
                path: 'enterprise',
                canActivate: [EnterpriseSubscriptionGuard, AccountsGuard],
                canActivateChild: [EnterpriseSubscriptionGuard],
                data: { enterpriseModules: ['ACCOUNTING', 'GENERAL_LEDGER', 'SHIPMENTS'], enterpriseFeatureLabel: 'Finance' },
                children: [
                    {
                        path: 'journal-entries',
                        children: [
                            {
                                path: '',
                                component: JournalEntriesComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.journal.view }
                            },
                            {
                                path: 'add',
                                component: AddEditJournalEntryComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.journal.create }
                            },
                            {
                                path: 'import',
                                component: ImportJournalEntriesComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.journal.create }
                            },
                            {
                                path: 'view/:id',
                                component: JournalEntryDetailComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.journal.view }
                            },
                            {
                                path: 'edit/:id',
                                component: AddEditJournalEntryComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.journal.edit }
                            }
                        ]
                    },
                    {
                        path: 'ledgers',
                        children: [
                            {
                                path: 'general-ledger',
                                component: GeneralLedgerComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view }
                            },
                            {
                                path: 'partner-ledger',
                                component: PartnerLedgerComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view }
                            }
                        ],
                    },
                    {
                        path: 'payment-transactions',
                        component: PaymentTransactionsComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.accounts.voucher.view }
                    },
                    {
                        path: 'banking',
                        children: [
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'bank-accounts'
                            },
                            {
                                path: 'bank-accounts',
                                component: BankAccountsComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_account_entry.view }
                            },
                            {
                                path: 'bank-accounts/new',
                                component: BankAccountFormComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_account_entry.create }
                            },
                            {
                                path: 'bank-accounts/:id',
                                component: BankAccountViewComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_account_entry.view }
                            },
                            {
                                path: 'bank-accounts/:id/edit',
                                component: BankAccountFormComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_account_entry.edit }
                            },
                            {
                                path: 'banks',
                                component: BanksComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_account_entry.view }
                            }
                        ]
                    },
                    {
                        path: 'bank-reconciliation',
                        component: BankReconciliationShellComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.accounts.bank_reconciliation.view },
                        children: [
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'dashboard'
                            },
                            {
                                path: 'dashboard',
                                component: BankReconciliationDashboardComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.view }
                            },
                            {
                                path: 'statements',
                                component: BankStatementsComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.view }
                            },
                            {
                                path: 'statements/import',
                                component: BankStatementImportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.import }
                            },
                            {
                                path: 'statements/:statementId',
                                component: BankStatementDetailComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.view }
                            },
                            {
                                path: 'sessions/:sessionId',
                                component: BankReconciliationWorkspaceComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.manage }
                            },
                            {
                                path: 'exceptions',
                                component: BankReconciliationExceptionsComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.manage }
                            },
                            {
                                path: 'reports',
                                component: BankReconciliationReportsComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.view }
                            },
                            {
                                path: 'reports/unmatched-bank-lines',
                                component: BankReconciliationReportsComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.view, reportType: 'unmatched-bank-lines' }
                            },
                            {
                                path: 'reports/uncleared-book-transactions',
                                component: BankReconciliationReportsComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.view, reportType: 'uncleared-book-transactions' }
                            },
                            {
                                path: 'reports/outstanding-items',
                                component: BankReconciliationReportsComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.view, reportType: 'outstanding-items' }
                            },
                            {
                                path: 'reports/variance',
                                component: BankReconciliationReportsComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.view, reportType: 'variance' }
                            },
                            {
                                path: 'reports/exception-aging',
                                component: BankReconciliationReportsComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.view, reportType: 'exception-aging' }
                            },
                            {
                                path: 'reports/session/:sessionId',
                                component: BankReconciliationStatementReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.view }
                            },
                            {
                                path: 'rules',
                                component: BankReconciliationRulesComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.manage }
                            },
                            {
                                path: 'rules/new',
                                component: BankReconciliationRuleFormComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.manage }
                            },
                            {
                                path: 'rules/:ruleId/edit',
                                component: BankReconciliationRuleFormComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bank_reconciliation.manage }
                            }
                        ]
                    },
                    {
                        path: 'cost-center',
                        component: CostCenterComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.accounts.cost_center.view }
                    },
                    {
                        path: 'workforce-finance',
                        children: [
                            { path: '', component: WorkforceCashWorkbenchComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.workforce_finance.view } },
                            { path: 'advances/new', component: WorkforceCashFormComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.workforce_finance.cash_manage, kind: 'advance' } },
                            { path: 'advances/:id', component: WorkforceCashDetailComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.workforce_finance.view, kind: 'advance' } },
                            { path: 'settlements/new', component: WorkforceCashFormComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.workforce_finance.cash_manage, kind: 'settlement' } },
                            { path: 'settlements/:id', component: WorkforceCashDetailComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.workforce_finance.view, kind: 'settlement' } },
                            { path: 'earnings/new', component: WorkforceEarningFormComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.workforce_finance.earnings_manage } },
                            { path: 'rate-cards/new', component: WorkforceRateCardFormComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.workforce_finance.rates_manage } },
                            { path: 'payouts/new', component: WorkforcePayoutFormComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.workforce_finance.payouts_manage } }
                        ]
                    },
                    {
                        path: 'admin',
                        children: [
                            {
                                path: 'accounting-period-locks',
                                component: AccountingPeriodLocksComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.period_lock.manage }
                            },
                            {
                                path: 'manual-entry-controls',
                                component: ManualEntryControlsComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.manual_entry.manage }
                            }
                        ]
                    },
                    {
                        path: 'receivables',
                        children: [
                            {
                                path: 'invoice-dispatches',
                                children: [
                                    { path: '', component: InvoiceDispatchComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.invoice.view } },
                                    { path: 'new', component: InvoiceDispatchComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.invoice.create } },
                                    { path: 'view/:id', component: InvoiceDispatchComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.invoice.view } }
                                ]
                            },
                            {
                                path: 'to-be-invoiced',
                                component: ReceivablesComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.invoice.view }
                            },
                            {
                                path: 'to-be-invoiced/view/:id',
                                component: ReceivableDetailComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.invoice.view }
                            },
                            {
                                path: 'to-be-invoiced/manual',
                                component: ManualReceivableEntryComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.invoice.create }
                            },
                            {
                                path: 'to-be-invoiced/manual/:id',
                                component: ManualReceivableEntryComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.invoice.edit }
                            },
                            {
                                path: 'generated-invoices',
                                children: [
                                    {
                                        path: '',
                                        component: GeneratedInvoicesComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.invoice.view }
                                    },
                                    {
                                        path: 'view/:id',
                                        component: InvoiceDetailComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.invoice.view }
                                    },
                                    {
                                        path: 'manual-draft',
                                        component: ManualInvoiceDraftComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.invoice.create }
                                    },
                                    {
                                        path: 'manual-draft/:id',
                                        component: ManualInvoiceDraftComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.invoice.edit }
                                    }
                                ]
                            },
                            {
                                path: 'generated-receipts',
                                children: [
                                    {
                                        path: '',
                                        component: GeneratedReceiptsComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.receipt.view }
                                    },
                                    {
                                        path: 'view/:id',
                                        component: ReceiptDetailComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.receipt.view }
                                    },
                                    {
                                        path: 'add',
                                        component: ReceiptEntryComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.receipt.create }
                                    },
                                    {
                                        path: 'edit/:id',
                                        component: ReceiptEntryComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.receipt.edit }
                                    }
                                ]
                            },
                            {
                                path: 'apply-receipts-invoice/:receiptId',
                                component: ApplyReceiptInvoiceComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.receipt.edit }
                            },
                            {
                                path: 'customer-credit-note',
                                children: [
                                    { path: '', component: NewFinanceNotesComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.customer_credit_note.view, kind: 'customer-credit-notes', mode: 'list' } },
                                    { path: 'add', component: NewFinanceNotesComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.customer_credit_note.create, kind: 'customer-credit-notes', mode: 'add' } },
                                    { path: 'view/:id', component: NewFinanceNotesComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.customer_credit_note.view, kind: 'customer-credit-notes', mode: 'view' } },
                                    { path: 'edit/:id', component: NewFinanceNotesComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.customer_credit_note.edit, kind: 'customer-credit-notes', mode: 'edit' } }
                                ]
                            },
                            {
                                path: 'debit-note',
                                children: [
                                    {
                                        path: '',
                                        component: DebitNoteComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.debit_note.view }
                                    },
                                    {
                                        path: 'view/:id',
                                        component: DebitNoteDetailComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.debit_note.view }
                                    },
                                    {
                                        path: 'add',
                                        component: AddEditDebitNoteComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.debit_note.create }
                                    },
                                    {
                                        path: 'edit/:id',
                                        component: AddEditDebitNoteComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.debit_note.edit }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'payables',
                        children: [
                            {
                                path: 'to-be-billed',
                                component: PayablesComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bill.view }
                            },
                            {
                                path: 'to-be-billed/view/:id',
                                component: PayableDetailComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bill.view }
                            },
                            {
                                path: 'to-be-billed/manual',
                                component: ManualPayableEntryComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bill.create }
                            },
                            {
                                path: 'to-be-billed/manual/:id',
                                component: ManualPayableEntryComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bill.edit }
                            },
                            {
                                path: 'matching-dashboard',
                                component: MatchingDashboardComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bill.view }
                            },
                            {
                                path: 'matching-policies',
                                component: MatchingPoliciesComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bill.edit }
                            },
                            {
                                path: 'payment-proposals',
                                children: [
                                    {
                                        path: '',
                                        component: PaymentProposalsComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.voucher.view }
                                    },
                                    {
                                        path: 'view/:id',
                                        component: PaymentProposalDetailComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.voucher.view }
                                    }
                                ]
                            },
                            {
                                path: 'vendor-statement-reconciliation',
                                component: VendorStatementReconciliationComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.bill.view }
                            },
                            {
                                path: 'bulk-costs',
                                children: [
                                    {
                                        path: '',
                                        component: BulkCostsComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.bill.view }
                                    },
                                    {
                                        path: 'new',
                                        component: BulkCostFormComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.bill.edit }
                                    },
                                    {
                                        path: 'account-defaults',
                                        component: BulkCostAccountDefaultsComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.bill.edit }
                                    },
                                    {
                                        path: ':id/edit',
                                        component: BulkCostFormComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.bill.edit }
                                    },
                                    {
                                        path: ':id',
                                        component: BulkCostDetailComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.bill.view }
                                    }
                                ]
                            },
                            {
                                path: 'generated-bills',
                                children: [
                                    {
                                        path: '',
                                        component: GeneratedBillsComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.bill.view }
                                    },
                                    {
                                        path: 'view/:id',
                                        component: BillDetailComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.bill.view }
                                    },
                                    {
                                        path: 'non-po-draft',
                                        component: NonPoBillDraftComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.bill.create }
                                    },
                                    {
                                        path: 'non-po-draft/:id',
                                        component: NonPoBillDraftComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.bill.edit }
                                    }
                                ]
                            },
                            {
                                path: 'generated-vouchers',
                                children: [
                                    {
                                        path: '',
                                        component: GeneratedVouchersComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.voucher.view }
                                    },
                                    {
                                        path: 'view/:id',
                                        component: VoucherDetailComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.voucher.view }
                                    },
                                    {
                                        path: 'add',
                                        component: VoucherEntryComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.voucher.create }
                                    },
                                    {
                                        path: 'edit/:id',
                                        component: VoucherEntryComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.voucher.edit }
                                    }
                                ]
                            },
                            {
                                path: 'apply-vouchers-bill/:voucherId',
                                component: ApplyVoucherBillComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.voucher.edit }
                            },
                            {
                                path: 'vendor-debit-note',
                                children: [
                                    { path: '', component: NewFinanceNotesComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.vendor_debit_note.view, kind: 'vendor-debit-notes', mode: 'list' } },
                                    { path: 'add', component: NewFinanceNotesComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.vendor_debit_note.create, kind: 'vendor-debit-notes', mode: 'add' } },
                                    { path: 'view/:id', component: NewFinanceNotesComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.vendor_debit_note.view, kind: 'vendor-debit-notes', mode: 'view' } },
                                    { path: 'edit/:id', component: NewFinanceNotesComponent, canActivate: [PermissionGuard], data: { permission: app_permissions.accounts.vendor_debit_note.edit, kind: 'vendor-debit-notes', mode: 'edit' } }
                                ]
                            },
                            {
                                path: 'credit-note',
                                children: [
                                    {
                                        path: '',
                                        component: CreditNoteComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.credit_note.view }
                                    },
                                    {
                                        path: 'view/:id',
                                        component: CreditNoteDetailComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.credit_note.view }
                                    },
                                    {
                                        path: 'add',
                                        component: AddEditCreditNoteComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.credit_note.create }
                                    },
                                    {
                                        path: 'edit/:id',
                                        component: AddEditCreditNoteComponent,
                                        canActivate: [PermissionGuard],
                                        data: { permission: app_permissions.accounts.credit_note.edit }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'compliance',
                        children: [
                            {
                                path: '',
                                component: GovernmentOnboardingComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view }
                            },
                            {
                                path: 'e-invoices',
                                component: EInvoiceComplianceWorkbenchComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view }
                            },
                            {
                                path: 'zatca-onboarding',
                                component: ZatcaOnboardingComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view }
                            }
                        ]
                    },
                    {
                        path: 'reports',
                        children: [
                            {
                                path: 'profit-and-loss',
                                component: ProfitAndLossComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view }
                            },
                            {
                                path: 'balance-sheet',
                                component: BalanceSheetComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view }
                            },
                            {
                                path: 'trial-balance',
                                component: TrialBalanceComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view }
                            },
                            {
                                path: 'tax-report',
                                component: TaxReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view }
                            },
                            {
                                path: 'sales-register',
                                component: SalesRegisterComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view }
                            },
                            {
                                path: 'aged-receivable',
                                component: AgingReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view, agingMode: 'receivable' }
                            },
                            {
                                path: 'aged-payable',
                                component: AgingReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view, agingMode: 'payable' }
                            },
                            {
                                path: 'cash-flow',
                                component: StandardReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view, reportCode: 'cash-flow', title: 'Cash Flow Statement', subtitle: 'Review operating, investing, and financing cash movements.' }
                            },
                            {
                                path: 'executive-summary',
                                component: StandardReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view, reportCode: 'executive-summary', title: 'Executive Financial Summary', subtitle: 'Monitor core CFO financial and working-capital KPIs.' }
                            },
                            {
                                path: 'customer-statements',
                                component: StandardReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view, reportCode: 'customer-statements', title: 'Customer Statements', subtitle: 'Review customer debits, credits, and running balances.' }
                            },
                            {
                                path: 'supplier-statements',
                                component: StandardReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view, reportCode: 'supplier-statements', title: 'Supplier Statements', subtitle: 'Review supplier debits, credits, and running balances.' }
                            },
                            {
                                path: 'ar-register',
                                component: StandardReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view, reportCode: 'ar-register', title: 'AR Register & Payment History', subtitle: 'Trace invoices, applications, and outstanding customer balances.' }
                            },
                            {
                                path: 'ap-register',
                                component: StandardReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view, reportCode: 'ap-register', title: 'AP Register & Payment History', subtitle: 'Trace bills, voucher applications, and outstanding supplier balances.' }
                            },
                            {
                                path: 'bank-cash',
                                component: StandardReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view, reportCode: 'bank-cash', title: 'Bank & Cash Report', subtitle: 'Review cash-account movement, balances, and reconciliation status.' }
                            },
                            {
                                path: 'fixed-assets',
                                component: StandardReportComponent,
                                canActivate: [PermissionGuard],
                                data: { permission: app_permissions.accounts.reports.view, reportCode: 'fixed-assets', title: 'Fixed Asset Register', subtitle: 'Review acquisition values, depreciation, and net book value.' }
                            },
                        ]
                    },
                ]
            },
        ]
    },
];
